import Resource from './Resource';

export default class GraduationProgress extends Resource {
	constructor(options={}) {
		let {
			route = 'graduation-progress',
			query = {}
		} = options;

		let config = {
			route: route,
			query: query,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
